import React, { useState, useEffect } from 'react';
import { Pagination } from 'react-bootstrap';
import Helpers from 'utils/helpers';

export default function Pager(props) {
  const [activePage, setActivePage] = useState(1);

  useEffect(() => {
    setActivePage(props.active);
  }, [props.active]);

  const handlePageChange = (page) => {
    if (page !== activePage) {
      setActivePage(page);
      if (props.onChange) {
        props.onChange(page);
      }
    }
  };

  const renderPages = () => {
    const pageList = pages(activePage, props.pages);
    let items = [];
    for (let i = 0; i < pageList.length; i++) {
      const page = pageList[i];
      if (page === '...') {
        const half = pageList[i - 1] + Math.floor((pageList[i + 1] - pageList[i - 1]) / 2);
        items.push(
          <Pagination.Ellipsis key={i} onClick={() => handlePageChange(half)} />
        );
      }
      else {
        items.push(
          <Pagination.Item key={i} active={page === activePage} onClick={() => handlePageChange(page)}>
            {page}
          </Pagination.Item>,
        );
      }
    }
    return items;
  };

  const getClass = () => {
    let classNames = [props.className];
    if (props.align) {
      switch (props.align) {
        case 'left':
          classNames.push('justify-content-start');
          break;
        case 'center':
          classNames.push('justify-content-center');
          break;
        case 'right':
          classNames.push('justify-content-end');
          break;
        default:
          break;
      }
    }
    else {
      classNames.push('justify-content-end');
    }
    return Helpers.String.join(classNames);
  };

  if (!props.pages || props.pages <= 1) {
    return null;
  }

  return (
    <Pagination className={getClass()}>
      {/*<Pagination.First className='page-icon' onClick={() => handlePageChange(1)} />*/}
      <Pagination.Prev className='page-icon' onClick={() => handlePageChange(Math.max(activePage - 1, 1))} />
      {renderPages()}
      <Pagination.Next className='page-icon' onClick={() => handlePageChange(Math.min(activePage + 1, props.pages))} />
      {/*<Pagination.Last className='page-icon' onClick={() => handlePageChange(props.pages)} />*/}
    </Pagination>
  );
}

function pages(active, length) {
  var current = active,
    last = length,
    delta = 2,
    left = current - delta,
    right = current + delta + 1,
    range = [],
    rangeWithDots = [],
    l;

  for (let i = 1; i <= last; i++) {
    if (i === 1 || i === last || (i >= left && i < right)) {
      range.push(i);
    }
  }

  for (let i of range) {
    if (l) {
      if (i - l === 2) {
        rangeWithDots.push(l + 1);
      }
      else if (i - l !== 1) {
        rangeWithDots.push('...');
      }
    }
    rangeWithDots.push(i);
    l = i;
  }

  return rangeWithDots;
}
